import { action, createRequestTypes } from "./base";

export const cartActionTypes = {
  GET_CART: createRequestTypes("GET_CART"),
  ADD_TO_CART: createRequestTypes("ADD_TO_CART"),
  GET_SKU_AVAILABILITY: createRequestTypes("GET_SKU_AVAILABILITY"),
};

class CartActions {

  getCart = (tenantId, callback) =>
    action(cartActionTypes.GET_CART.REQUEST, { tenantId, callback });

  getCartLoading = (getCartLoading) =>
    action(cartActionTypes.GET_CART.LOADING, {
      getCartLoading,
    });

  getCartSuccess = (cart) =>
    action(cartActionTypes.GET_CART.SUCCESS, {
      cart,
    });

  addToCart = (payload, tenantId, callback) =>
    action(cartActionTypes.ADD_TO_CART.REQUEST, {
      payload,
      tenantId,
      callback,
    });

  addToCartLoading = (addToCartLoading) =>
    action(cartActionTypes.ADD_TO_CART.LOADING, {
      addToCartLoading,
    });

    getSKUAvailability = (payload, callback) => action(cartActionTypes.GET_SKU_AVAILABILITY.REQUEST, {
      payload, callback,
    })
  
    getSKUAvailabilityLoading = (getSKUAvailabilityLoading) => action(cartActionTypes.GET_SKU_AVAILABILITY.LOADING, {
      getSKUAvailabilityLoading,
    })
  
    getSKUAvailabilitySuccess = (skuAvailability) => action(cartActionTypes.GET_SKU_AVAILABILITY.SUCCESS, {
      skuAvailability,
    })
}

export default new CartActions();
